import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "table table-sm table-bordered" }
const _hoisted_4 = { class: "text-end" }
const _hoisted_5 = { class: "text-end" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-md-10" }
const _hoisted_8 = { class: "row mb-2" }
const _hoisted_9 = { class: "col-md-10" }
const _hoisted_10 = { class: "row mb-2" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "row mb-2" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "col-md-9 fw-bold text-danger" }
const _hoisted_16 = {
  key: 1,
  class: "row"
}
const _hoisted_17 = { class: "col-md-9 fw-bold" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = ["disabled"]

import { onMounted, reactive, watch } from "vue";
import { useRouter } from "vue-router";

//servicos
import * as service from "@/services/BoletosService";
import { f2dec, fdata} from "@/utils/funcoes";

//componentes
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import DropdownParamBoleto from "@/components/Dropdowns/DropdownParamBoleto.vue";
import Loading from "@/components/Loading/index.vue";

interface IProps {
    boletos: service.Boleto[],
    exibir: boolean
}

interface IResumo {
    ocorrenciaId: string;
    descricao: string;
    qtde: number;
    total: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GerarRemessa',
  props: {
    boletos: {},
    exibir: { type: Boolean }
  },
  emits: ["gerou","erro", "fechou"],
  setup(__props: any, { emit: __emit }) {


//vue
var props = __props;
var emit = __emit;

var router = useRouter();

var controle = reactive({ 
    
    janRemessa: false,
    param: {
        paramBoletoId: 1,
    } as service.GerarRemessaDTO,
    resumo: [] as IResumo[],
    remessa: {} as service.BoletoRemessa,
    gerou : false,
    loading: false,
    status: "",
    erro: ""
});

onMounted(() => {

    montarResumo();

})

watch(() => props.boletos, async(novoValor ) => {
    controle.param.boletosIds = novoValor.map(b => b.boletoId);
    
    montarResumo();
})

watch(() => props.exibir, async (novoValor) => {

    controle.janRemessa = novoValor;
    controle.gerou = false;

    if (controle.janRemessa == true)
    {
        setTimeout(() => {
            var jan = document.getElementById("janRemessa");
            var el = jan?.querySelector("#inputFocus") as HTMLInputElement;
            if (el != undefined)
                el.focus();
        }, 700);
    }

    montarResumo();

})



async function gerar(){

    controle.erro = "";
    controle.status = "";
    controle.loading = true;

    controle.status = `Gerando remessa ...`;
    
    console.log("Gerando remessa", controle.param);

    await service.gerarRemessa(controle.param)
    .then(r=> {
        controle.status =  `Gerado com sucesso!`;
        controle.gerou = true;
        controle.remessa = r;
        emit("gerou");

        setTimeout(() => {
            controle.loading = false;
            controle.janRemessa = false;
            router.push("/boletosRemessas");
        }, 1500);


    })
    .catch((erro) => {
        controle.erro = erro;
        controle.status = "Erro: " + erro ;
        controle.loading = false;
        emit("erro", erro);
    });
}

function fechar() {
    controle.janRemessa = false;
    emit("fechou");
}

const montarResumo = ()=> {

    controle.resumo = [] as IResumo[];

    const grupos = Object.groupBy(props.boletos, ({ ocorrenciaId }) => ocorrenciaId);

    Object.keys(grupos).forEach(function (key: string) {

        var itens = props.boletos.filter(a => a.ocorrenciaId == key);

        if (itens.length == 0)
            return;
        
        var grupo = {
            ocorrenciaId: key,
            descricao: itens[0].ocorrencia?.descricao,
            qtde: itens.length,
            total: itens.reduce((total, boleto) => total + (boleto.valorDocumento ?? 0), 0)
        } as IResumo;

        controle.resumo.push(grupo);
    });
}

function baixar()
{
    controle.loading = true;
    controle.status = "Baixando arquivo de remessa...";

    service.baixarRemessa(controle.remessa.remessaId!)
        .then((r) => {
            controle.loading = false;
            controle.status = "";
            const link = document.createElement('a');
            link.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(r);
            link.download = `remessa_${controle.remessa?.paramBoletoId}_${fdata(new Date())}.txt`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch((erro: string) => {
            controle.loading = false;
            controle.status = "";
            MsgBox.showError("Erro ao baixar arquivo de remessa", erro);
        });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loading, {
      isLoading: _unref(controle).loading,
      mensagem: _unref(controle).status
    }, null, 8, ["isLoading", "mensagem"]),
    _createVNode(MsgBox, {
      id: 'janRemessa',
      titulo: 'Gerar Remessa',
      exibir: _unref(controle).janRemessa,
      onOnFechou: _cache[7] || (_cache[7] = ($event: any) => (_unref(controle).janRemessa = false))
    }, {
      default: _withCtx(() => [
        _createVNode(TrataTecla, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-md-12" }, [
                _createElementVNode("h5", null, "Resumo dos boletos selecionados")
              ], -1)),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("table", _hoisted_3, [
                  _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Ocorrência"),
                      _createElementVNode("th", null, "Código"),
                      _createElementVNode("th", { class: "text-end" }, "Qtde"),
                      _createElementVNode("th", { class: "text-end" }, "Total")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).resumo, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.ocorrenciaId
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.descricao), 1),
                        _createElementVNode("td", null, _toDisplayString(item.ocorrenciaId), 1),
                        _createElementVNode("td", _hoisted_4, _toDisplayString(item.qtde), 1),
                        _createElementVNode("td", _hoisted_5, "R$ " + _toDisplayString(_unref(f2dec)(item.total)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-md-2" }, " Convênio ", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(DropdownParamBoleto, {
                  modelValue: _unref(controle).param.paramBoletoId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).param.paramBoletoId) = $event)),
                  id: "inputFocus  "
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-md-2" }, " Destino ", -1)),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).param.destino) = $event)),
                  class: "form-select form-select-sm"
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("option", { value: "arquivo" }, "Arquivo", -1),
                  _createElementVNode("option", { value: "api" }, "Api", -1)
                ]))], 512), [
                  [_vModelSelect, _unref(controle).param.destino]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-md-2" }, [
                _createElementVNode("label", null, "Usuário")
              ], -1)),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).param.nomeUsuario) = $event)),
                  id: "nomeUsuario",
                  ref: "nomeUsuario"
                }, null, 512), [
                  [_vModelText, _unref(controle).param.nomeUsuario]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-md-2" }, [
                _createElementVNode("label", null, "Senha")
              ], -1)),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).param.senha) = $event)),
                  ref: "senha"
                }, null, 512), [
                  [_vModelText, _unref(controle).param.senha]
                ])
              ])
            ]),
            (_unref(controle).erro != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-md-3" }, null, -1)),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(controle).erro), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(controle).status != '' && _unref(controle).erro == '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-md-3" }, null, -1)),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-cog fa-spin" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(controle).status), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "col-md-12" }, [
                _createElementVNode("hr")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (!_unref(controle).gerou)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (gerar())),
                      disabled: _unref(controle).loading
                    }, "Gerar", 8, _hoisted_20))
                  : _createCommentVNode("", true),
                (_unref(controle).gerou == true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (baixar()))
                    }, "Baixar"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("a", {
                  class: "btn btn-secondary btn-sm float-end",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (fechar())),
                  disabled: _unref(controle).loading
                }, "Fechar", 8, _hoisted_22)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})